import React, { useEffect, useCallback, useState} from 'react';
import Colors from "components/Colors.js";
import ZObjectComponent from "components/zobject/ZObjectComponent.js";
import {
    setSelectedZObject} from 'actions/index.js';
import {sleep} from "utils/sleep.js"
import TrackFrozenComponent from "components/v2/TrackFrozenComponent.js";
import {connect} from 'react-redux';
import './liveloop.scss';
import {
    OFF,
    PREPARING,
    RECORDING,
    STOPPING} from 'constants/recording-modes.js';

const colors = new Colors();

const LiveLoopTrackComponent = ({track, _mode, setSelectedZObject, countdown}) => { 
    let [mode, setMode] = useState(track.recordingMode);
    let [zobject, setZObject] = useState(track._zobject);
    let [main, setMain] = useState(track._main);

    useEffect(() => {
        setMode(_mode);
        if (main) {
            if (_mode === RECORDING) {
                main.effect.inletObjects[1].sendMessage("Output", 2);
            } else if (_mode === OFF) {
                main.effect.inletObjects[1].sendMessage("Output", 1);
            }
        }
    }, [_mode, main]);

    useEffect(() => {
        let {sequencerEngine} = track;
        if (zobject) {
            return;
        }
        sequencerEngine.currentSubSequence.loadSubPatch("Mode5 Tape Machine")
            .then(
                async x => {
                    setSelectedZObject(undefined);
                    // todo: get inbound ones
                    let outbound = x.effect.getOutboundNodes();
                    while (Object.keys(outbound).length === 0) {
                        await sleep(100);
                        outbound = x.effect.getOutboundNodes();
                    }

                    let canvas = outbound["Output 1"][0].node.zObject;
                    canvas.width = 160;
                    canvas.height = 160;
                    canvas.effect.sendMessage("size", [160,160]);
                    canvas.hide();
                    x.hide();
                    setZObject(canvas);
                    setMain(x);
                    track._main = x;
                    track._zobject = canvas;
                    setSelectedZObject(undefined);
                });
        
    } , [setZObject]);

    const onClick = useCallback(() => {
        let _mode = undefined;
        if (mode === OFF) {
            track.recordingMode = PREPARING;
            setMode(PREPARING);
        }  else if (mode === RECORDING) {
            track.recordingMode = STOPPING;
            setMode(STOPPING);
        } else if (mode === PREPARING) {
            // cancel scheduled recording
            track.recordingMode = OFF;
            setMode(OFF);
        }
    }, [setMode, mode, track]);

    useEffect(() => {
        if (track && main) {
            main.setAttribute(
                "reelColor",
                colors.getColorForHash(track.id));
        }
    }, [track, main]);

    let className = "record-btn ";
    className += mode === OFF ? " off " : mode === STOPPING || mode === PREPARING ? " preparing " : " recording";
    if (mode === OFF || mode === RECORDING) {
        className += " pushable";
    }
    return (
        <div className="live-loop-track">
          {zobject && <ZObjectComponent forceShow={true} zobject={zobject}/>}
          <div className="btn-and-countdown">
            <div onClick={onClick} className={className}></div>
            {mode === PREPARING && !isNaN(countdown) && <div className="countdown">{Math.round(countdown / 4)}</div>}
          </div>
          <TrackFrozenComponent
            track={track}
            trackColor={track.color}
            isTrackFrozen={true}/>
        </div>
    );
};

const mapStateToProps = (state, props) => {
  return {
      _mode: props.track.recordingMode,
      countdown: props.track.countdown
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
      setSelectedZObject: x => dispatch(setSelectedZObject(x))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(LiveLoopTrackComponent);
